import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from "@angular/common/http";
import { ParamsService } from "../services/params.service";

@Injectable()
export class ParamsInterceptorService implements HttpInterceptor {
  constructor(private paramsService: ParamsService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let params: URLSearchParams = new URLSearchParams(window.location.search);
    this.paramsService.limpiarParametros();
    this.paramsService.procesarParametros(params);
    return next.handle(request);
  }
}
